import { BaseHTTPClient } from '../api/http-client.service';
import { APIType } from '../api/configuration';

export class UserService extends BaseHTTPClient {
    // The caller's identity is derived from the JWT server-side. Do NOT pass
    // ?user_email=... — the backend will reject the request with 403
    // identity_mismatch if the query param disagrees with the token identity.
    public static async getTenants() {
        return this.sendToGateway({
            url: `${process.env.REACT_APP_API_URL}/user/tenants`,
            method: APIType.GET,
        });
    }

    public static async getUsers() {
        return this.sendToGateway({
            url: `${process.env.REACT_APP_API_URL}/user/list`,
            method: APIType.GET,
        });
    }

    public static async createUser(payload: any) {
        return this.sendToGateway({
            url: `${process.env.REACT_APP_API_URL}/user/create`,
            method: APIType.POST,
            data: payload,
        });
    }

    public static async updateUser(payload: any) {
        return this.sendToGateway({
            url: `${process.env.REACT_APP_API_URL}/user/edit`,
            method: APIType.PUT,
            data: payload,
        });
    }

    public static async deleteUser(payload: any) {
        return this.sendToGateway({
            url: `${process.env.REACT_APP_API_URL}/user/delete?userId=${payload.userId}&email=${payload.email}`,
            method: APIType.DELETE,
        });
    }

    public static async searchAdUsers(searchText: string) {
        return this.sendToGateway({
            url: `${process.env.REACT_APP_API_URL}/user/getadusers`,
            method: APIType.GET,
            data: { searchtext: searchText },
        });
    }

    public static async getRoles() {
        return this.sendToGateway({
            url: `${process.env.REACT_APP_API_URL}/roles`,
            method: APIType.GET,
        });
    }
}